import Pqp from "../../../3x1010/Pqp.js";

export default class Styler {
	constructor() {

	}

	setStyle(styleForced=-1) {
		let ret = new Object();
		let style = Pqp.rnd(Styler.BASE_STYLES - 1);
		if (styleForced !== -1) {
			style = styleForced;
		}
		ret.style = style;

		ret.walls = this.getStyleWalls(style);
		ret.fakeWalls = this.getStyleFakeWalls(style);
		ret.enterExit = this.getStyleEnterExit(style);
		ret.columns = this.getStyleColumns(style);
		ret.arches = this.getStyleArches(style);
		ret.floors = this.getStyleFloor(style);
		ret.doors = this.getStyleDoors(style);
		ret.doorsOpened = this.getStyleDoorsOpened(style);
		ret.paving = this.getStylePaving(style);
		this.style = style;
		this.kit = ret;
	}


	getStyleWalls(style) {
		let ret = new Array();
		if (style === Styler.STYLE_DUNGEON) {
			ret.push("walls0");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret.push("walls1");
		} else if (style === Styler.STYLE_CAVERN) {
			ret.push("walls2");
		} else if (style === Styler.STYLE_WOOD) {
			ret.push("walls3");
		} else if (style === Styler.STYLE_GRASS) {
			ret.push("walls4");
		}
		return ret;
	}

	getStyleFakeWalls(style) {
		let ret = new Array();
		if (style === Styler.STYLE_DUNGEON) {
			ret.push("fakewall0");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret.push("fakewall1");
		} else if (style === Styler.STYLE_CAVERN) {
			ret.push("fakewall2");
		} else if (style === Styler.STYLE_WOOD) {
			ret.push("fakewall3");
		} else if (style === Styler.STYLE_GRASS) {
			ret.push("fakewall4");
		}
		return ret;
	}

	getStyleEnterExit(style) {
		let ret = new Array();
		if (style === Styler.STYLE_DUNGEON) {
			ret.push("enterexit0");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret.push("enterexit1");
		} else if (style === Styler.STYLE_CAVERN) {
			ret.push("enterexit1");
		} else if (style === Styler.STYLE_WOOD) {
			ret.push("enterexit2");
		} else if (style === Styler.STYLE_GRASS) {
			ret.push("enterexit2");
		}
		return ret;
	}

	getStyleColumns(style) {
		let ret = new Array();
		if (style === Styler.STYLE_DUNGEON) {
			ret.push("columns0");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret.push("columns1");
		} else if (style === Styler.STYLE_CAVERN) {
			ret.push("columns1");
		} else if (style === Styler.STYLE_WOOD) {
			ret.push("columns2");
		} else if (style === Styler.STYLE_GRASS) {
			ret.push("columns3");
		}
		return ret;
	}

	getStyleArches(style) {
		let ret = new Array();
		if (style === Styler.STYLE_DUNGEON) {
			ret.push("arch0");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret.push("arch1");
		} else if (style === Styler.STYLE_CAVERN) {
			ret.push("arch1");
		} else if (style === Styler.STYLE_WOOD) {
			ret.push("arch2");
		} else if (style === Styler.STYLE_GRASS) {
			ret.push("arch3");
		}
		return ret;
	}

	getStyleFloor(style) {
		let ret = new Array();
		if (style === Styler.STYLE_DUNGEON) {
			ret.push("floor0");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret.push("floor1");
		} else if (style === Styler.STYLE_CAVERN) {
			ret.push("floor2");
		} else if (style === Styler.STYLE_WOOD) {
			ret.push("floor3");
			ret.push("floor4");
			ret.push("floor5");
			ret.push("floor6");
		} else if (style === Styler.STYLE_GRASS) {
			ret.push("floor7");
		}
		ret = Pqp.shuffle(ret);

		return ret;
	}

	getStyleDoors(style) {
		let ret = new Array();
		ret.push(new Array())
		ret.push(new Array())
		if (style === Styler.STYLE_DUNGEON) {
			ret[0].push("doorwooden");
			ret[1].push("doorspikes");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret[0].push("doorwooden");
			ret[1].push("doorspikes");
		} else if (style === Styler.STYLE_CAVERN) {
			ret[0].push("doorwooden");
			ret[1].push("doorspikes");
		} else if (style === Styler.STYLE_WOOD) {
			ret[0].push("doorwooden");
			ret[1].push("doorspikes");
		} else if (style === Styler.STYLE_GRASS) {
			ret[0].push("doorwooden");
			ret[1].push("doorspikes");
		}
		return ret;
	}

	getStyleDoorsOpened(style) {
		let ret = new Array();
		ret.push(new Array())
		ret.push(new Array())
		if (style === Styler.STYLE_DUNGEON) {
			ret[0].push("doorwoodenopened");
			ret[1].push("doorspikesopened");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret[0].push("doorwoodenopened");
			ret[1].push("doorspikesopened");
		} else if (style === Styler.STYLE_CAVERN) {
			ret[0].push("doorwoodenopened");
			ret[1].push("doorspikesopened");
		} else if (style === Styler.STYLE_WOOD) {
			ret[0].push("doorwoodenopened");
			ret[1].push("doorspikesopened");
		} else if (style === Styler.STYLE_GRASS) {
			ret[0].push("doorwoodenopened");
			ret[1].push("doorspikesopened");
		}
		return ret;
	}


	getStylePaving(style) {
		let ret = new Array();
		if (style === Styler.STYLE_DUNGEON) {
			ret.push("paving0");
			ret.push("paving1");
			ret.push("paving2");
			ret.push("paving3");
			ret.push("paving5");
			ret.push("floor0");
		} else if (style === Styler.STYLE_FORTRESS) {
			ret.push("paving0");
			ret.push("paving1");
			ret.push("paving4");
			ret.push("floor1");
			ret.push("floor6");
		} else if (style === Styler.STYLE_CAVERN) {
			ret.push("paving0");
			ret.push("paving1");
			ret.push("floor2");
			ret.push("floor4");
		} else if (style === Styler.STYLE_WOOD) {
			ret.push("paving3");
			ret.push("paving4");
			ret.push("paving5");
			ret.push("floor3");
			ret.push("floor4");
			ret.push("floor5");
			ret.push("floor6");
		} else if (style === Styler.STYLE_GRASS) {
			ret.push("paving6");
		}
		ret = Pqp.shuffle(ret);

		return ret;
	}

	getStyledId(id) {
		let o = this.kit;
		if (id === Styler.FLOOR) {
			return o.floors[0];
		} else if (id === Styler.WALLS) {
			return o.walls[0];
		} else if (id === Styler.DOOR_HORIZONTAL_OPENEND) {
			return o.doorsOpened[0][0];
		} else if (id === Styler.DOOR_VERTICAL_OPENEND) {
			return o.doorsOpened[1][0];
		} else if (id === Styler.DOOR_HORIZONTAL) {
			return o.doors[0][0];
		} else if (id === Styler.DOOR_VERTICAL) {
			return o.doors[1][0];
		} else if (id === Styler.ARCHES) {
			return o.arches[0];
		} else if (id === Styler.COLUMNS) {
			return o.columns[0];
		} else if (id === Styler.FAKEWALL) {
			return o.fakeWalls[0];
		} else if (id === Styler.ENTER_EXIT) {
			return o.enterExit[0];
		}

		/*
		ret.walls = this.getStyleWalls(style);
		ret.fakeWalls = this.getStyleFakeWalls(style);
		ret.enterExit = this.getStyleEnterExit(style);
		ret.columns = this.getStyleColumns(style);
		ret.arches = this.getStyleArches(style);
		ret.floors = this.getStyleFloor(style);
		ret.doors = this.getStyleDoors(style);
		ret.paving = this.getStylePaving(style);

*/


		return id;
	}



}

Styler.BASE_STYLES = 5;
Styler.STYLE_DUNGEON = 0;
Styler.STYLE_FORTRESS = 1;
Styler.STYLE_CAVERN = 2;
Styler.STYLE_WOOD = 3;
Styler.STYLE_GRASS = 4;

Styler.FLOOR = "floor";
Styler.WALLS = "walls";
Styler.DOOR_HORIZONTAL_OPENEND = "doorhorizontalopened";
Styler.DOOR_VERTICAL_OPENEND = "doorverticalopened";
Styler.DOOR_HORIZONTAL = "doorhorizontal";
Styler.DOOR_VERTICAL = "doorvertical";
Styler.ENTER_EXIT = "enterexit";
Styler.ARCHES = "arches";
Styler.COLUMNS = "columns";
Styler.CHESTS = "chests";
Styler.FIREPLACE = "fireplace";
Styler.FAKEWALL = "fakewall";